export default __webpack_public_path__ + "static/media/alipay-logo.88bea1e6.png";